import React from "react";
import { motion } from "framer-motion";
import CTAButton from "./CTAButton";
import { useSiteContent } from "../../hooks/useSiteContent";

export default function Stats() {
  const { content } = useSiteContent();
  const stats = [
    { value: content.stat1_value, label: content.stat1_label },
    { value: content.stat2_value, label: content.stat2_label },
    { value: content.stat3_value, label: content.stat3_label },
    { value: content.stat4_value, label: content.stat4_label },
  ];
  return (
    <section className="py-20 border-y border-border bg-card-gradient" data-testid="stats">
      <div className="container">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((s, i) => (
            <motion.div key={i} initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.08 }} className="text-center lg:text-left">
              <div className="font-display text-4xl lg:text-6xl font-light text-gold-gradient mb-2">{s.value}</div>
              <div className="text-xs uppercase tracking-[0.25em] text-muted-foreground">{s.label}</div>
            </motion.div>
          ))}
        </div>
        <CTAButton centered className="!mt-20" />
      </div>
    </section>
  );
}
